<div class="transaction_left--container bet-history--page myacc-cont">
  <div class="transaction_left--content">
    <div class="transaction_left--content_heading myacc-pages-hdng">
      <h2 class="heading"><p>{{'profileSettingsComp.gameHistory' | translate}}</p> <span class="back-icn" (click)="goBack()"> <small class="show-desk">✕</small><i class="icon icon-arrow-2 show-mobile"></i></span></h2>
    </div>    
    <div class="myaccount_inner_wrapper">
      <div class="container-fluid">
          <section class="my-transactions">
            <div class="clearfix"></div>
            <div class="transactions_topblock">
              <div class="transactions_container">
                <div class="">
                  <form [formGroup]="betHistoryDetails" (ngSubmit)="applyFilter('filterButton','')" novalidate
                    class="form-holder">
                    <div class="">
                      <div class="custom_padding period-from--field">
                        <h5>{{'bethistoryComp.bethistory5' | translate}}</h5>
                        <div class="form-group mobi-scroll type-select">
                          <input *ngIf="windowType === 'device'" type="text" [max]="maxDate" name="startDate" placeholder="{{'bethistoryComp.bethistory5' | translate}}:"
                            id="startDate" formControlName="startDate" mbsc-datepicker [options]="mobi_desktop_startDate" readonly>
                          <input *ngIf="windowType !== 'device'" type="text" [max]="maxDate" name="startDate" placeholder="{{'bethistoryComp.bethistory5' | translate}}:"
                            id="startDate" formControlName="startDate" mbsc-datepicker [options]="mobi_mobile_startDate" readonly>
                          <div #startDate disabled="false"></div>
                          <div class="arrow_box_small" *ngIf="shouldShowErrors('startDate',betHistoryDetails)">
                            {{getErrorMessage('startDate',betHistoryDetails)}}</div>
                        </div>
                        <!-- <div class="type-select">
                          <mat-form-field *ngIf="windowType === 'device'" class="custom_select_dropdown">
                            <input matInput [matDatepicker]="startDate" id="startDate" formControlName="startDate"
                              [max]="maxDate" (dateInput)="resetDate(betHistoryDetails,'enddate')">
                            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate disabled="false"></mat-datepicker>
                            <div class="arrow_box_small" *ngIf="shouldShowErrors('startDate',betHistoryDetails)">
                              {{getErrorMessage('startDate',betHistoryDetails)}}</div>
                          </mat-form-field>
                        </div>
                    
                        <div class="form-group mobi-scroll type-select" *ngIf="windowType === 'mobile'">
                          <input type="date" name="startDate" placeholder="{{'placeholder.periodfrom' | translate}}" id="startDate"
                            formControlName="startDate" mbsc-date [mbsc-options]="mobiDatePicker_start" [max]="maxDate">
                          <div #startDate disabled="false"></div>
                          <div class="arrow_box_small" *ngIf="shouldShowErrors('startDate',betHistoryDetails)">
                            {{getErrorMessage('startDate',betHistoryDetails)}}</div>
                        </div>-->
                      </div> 
                      <div class="custom_padding period-to--field">
                        <h5>{{'bethistoryComp.bethistory6' | translate}}</h5>
                        <div class="form-group mobi-scroll type-select" >
                          <input *ngIf="windowType === 'device'" type="text" [max]="maxDate" name="endDate" placeholder="{{'bethistoryComp.bethistory6' | translate}}:"
                            id="endDate" formControlName="endDate" mbsc-datepicker [options]="mobi_desktop_endDate" readonly>
                          <input *ngIf="windowType !== 'device'" type="text" [max]="maxDate" name="endDate" placeholder="{{'bethistoryComp.bethistory6' | translate}}:"
                            id="endDate" formControlName="endDate" mbsc-datepicker [options]="mobi_mobile_endDate" readonly>
                          <div #endDate disabled="false"></div>
                           <div class="arrow_box_small" *ngIf="shouldShowErrors('endDate',betHistoryDetails)">
                            {{getErrorMessage('endDate',betHistoryDetails)}}</div>
                        </div> 
                      </div>
                      <div class="custom_padding transaction-type--field">
                        <h5>{{'bethistoryComp.bethistory7' | translate}}</h5>
                        <div class="type-select">
                          <select name="items" placeholder="Number of items" formControlName="items">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                          </select>
                          <div *ngIf="shouldShowErrors('items',betHistoryDetails)">
                            {{getErrorMessage('items',betHistoryDetails)}}</div>
                        </div>
                      </div>
                      <div class="custom_padding">
                        <button id="filterButton" class="squarebutton filter-btn prefer_btn site-btn site-btn--lg"
                          type="button" (click)="applyFilter('filterButton','')"
                          [disabled]="isButtonDisabled(betHistoryDetails)">
                          <span class='button-text'>{{'bethistoryComp.bethistory8' | translate}}</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
      </div>
      <div class="clearfix"></div>
      <div class="container-fluid">
          <div class="table-content custom_table">
            <div class="custom_table-tabledata">
              <ng-container *ngIf="!betHistory">
                <div class="transaction_history_block">
                  <h5>{{'bethistoryComp.bethistory9' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.gameName' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.bethistory11' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.bethistory12' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.bethistory13' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.bethistory14' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                </div>
              </ng-container>
              <ng-container *ngIf="betHistory && betHistory.length === 0">
                <div class="transaction_history_block">
                  {{'bethistoryComp.bethistory16' | translate}}
                </div>
              </ng-container>
              <ng-container *ngIf="betHistory?.length > 0">
                  <ng-container *ngFor="let bet of betHistory;let last = last;">
                  <div class="transaction_history_block" *ngIf="!(last && betHistory.length == noOfTransactions)">
                    <!-- <div class="status-icn">
                      <i class="icon icon-checkbox success" *ngIf="bet.txnStatus ==='SUCCESS'"></i>
                      <i class="icon icon-close-simplified pending" *ngIf="bet.txnStatus !=='SUCCESS'"></i>
                    </div> -->
                    <div class="table-data">
                      <h5>{{'bethistoryComp.bethistory9' | translate}}</h5>
                      <p>{{ bet.transactionTime  | date : "longDate" }} {{ bet.transactionTime | date : "mediumTime" }}</p>
                    </div>
                    <div class="table-data">
                      <h5>{{'bethistoryComp.gameName' | translate}}</h5>
                      <p>
                        {{bet.gameName ? bet.gameName.split("-").length > 1 ? bet.gameName.split("-")[1] : bet.gameName : bet.vendorName}}
                      </p>
                    </div>
                    <div class="table-data">
                      <h5>{{'bethistoryComp.bethistory11' | translate}}</h5>
                      <p>{{bet.betAmount | currencyPipe }} </p>
                    </div>
                    <div class="table-data">
                      <h5>{{'bethistoryComp.bethistory12' | translate}}</h5>
                      <p>{{bet.winAmount | currencyPipe}} </p>
                    </div>
                    <div class="table-data">
                      <h5>{{'bethistoryComp.bethistory13' | translate}}</h5>
                      <p>{{'bethistoryComp.bethistory15' | translate}}</p>
                    </div>
                    <div class="table-data">
                      <h5>{{'bethistoryComp.bethistory14' | translate}}</h5>
                      <p class="processbtn" *ngIf="bet.txnStatus ==='SUCCESS'">{{'bethistoryComp.success' | translate}}</p>
                      <p class="processbtn" *ngIf="bet.txnStatus !=='SUCCESS'">{{'bethistoryComp.pending' | translate}}</p>
                    </div>                    
                  </div>
                </ng-container>
              </ng-container>

              <div class="clearfix"></div>
              <div class="button_margin_mobile button actionbuuton bethistory_pagination--btn">
                <button [disabled]="request.index === 0 ? 'true' : ''"
                  [ngClass]="request.index === 0 ? 'hide':''" (click)="applyFilter('','less')" class="squarebutton filter-result--nextbtn">
                  <i class="icon-left-arrow"></i>
                  <span class="text">{{'bethistoryComp.bethistory17' | translate}}</span>
                </button>
                <button
                [disabled]="betHistory?.length == noOfTransactions ? '' :true"
                [ngClass]="betHistory?.length == noOfTransactions ? '' :'hide'"
                  
                  (click)="applyFilter('','more')" class="squarebutton filter-result--previousbtn">
                  <span class="text">{{'bethistoryComp.bethistory18' | translate}}</span>
                  <i class="icon-right-arrow"></i>
                </button>
              </div>

            </div>
            <div class="clearfix"></div>
          </div>
          <div class="loader-time" *ngIf="!betHistory">
          </div>
      </div>
    </div>
  </div>
</div>